document.addEventListener('DOMContentLoaded', () => {
	function fadeInPage() {
		const fader = document.querySelector('.loading-animation');

		const hasVisited = getCookie('hasVisited');
		if (!hasVisited) {
			fader.classList.add('loading-animation__first');
			setCookie('hasVisited', 'true', 365);
		}

		const hideFader = () => {
			fader.style.display = 'none';
			fader.classList.remove('loading-animation__fade-out');
			fader.classList.remove('loading-animation__fade-in');

			// After hiding the fader, handle scrolling to the anchor if present
			if (window.location.hash) {
				const targetId = window.location.hash.substring(1);
				const targetElement = document.getElementById(targetId);
				if (targetElement) {
					// Use a slight delay to ensure the browser has completed its default scroll
					setTimeout(() => {
						targetElement.scrollIntoView({ behavior: 'auto' });
					}, 0);
				}
			}
		};

		fader.classList.add('loading-animation__fade-out');
		fader.addEventListener('animationend', hideFader, { once: true });

		const anchors = document.querySelectorAll('a[href^="#"]'); // Select only internal anchors
		anchors.forEach((anchor) => {
			if (anchor.hostname !== window.location.hostname) return;

			const handleClickOrTouch = function (event) {
				const anchorUrl = anchor.href.split('#')[0];
				const targetId = anchor.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);

				// Check if the link is to an anchor on the same page
				if (
					anchorUrl === window.location.href.split('#')[0] &&
					targetElement
				) {
					event.preventDefault(); // Prevent default anchor behavior
					targetElement.scrollIntoView({ behavior: 'auto' }); // Scroll to target without smooth behavior
				} else {
					fader.style.display = 'flex';
					fader.classList.remove('loading-animation__fade-out');
					fader.classList.add('loading-animation__fade-in');
					window.location = anchor.href;
				}
			};

			anchor.addEventListener('click', handleClickOrTouch);
			anchor.addEventListener('touchstart', handleClickOrTouch, {
				passive: true,
			});
		});

		window.addEventListener('pageshow', function (event) {
			if (!event.persisted) return;
			fader.style.display = 'flex';
			fader.classList.add('loading-animation__fade-out');
			fader.addEventListener('animationend', hideFader, { once: true });
		});
	}

	function setCookie(name, value, days) {
		const expires = new Date(Date.now() + days * 864e5).toUTCString(); // days to milliseconds
		document.cookie =
			name +
			'=' +
			encodeURIComponent(value) +
			'; expires=' +
			expires +
			'; path=/';
	}

	function getCookie(name) {
		return document.cookie.split('; ').reduce((r, v) => {
			const parts = v.split('=');
			return parts[0] === name ? decodeURIComponent(parts[1]) : r;
		}, '');
	}

	fadeInPage();

	const popupTriggers = document.querySelectorAll('.js-popup-trigger');

	popupTriggers.forEach((trigger) => {
		trigger.addEventListener('click', function () {
			// Find the associated popup content (closest sibling)
			const popupContent = trigger.nextElementSibling;

			if (!popupContent) return;

			// Create overlay
			const overlay = document.createElement('div');
			overlay.className = 'js-popup-overlay';
			overlay.style.position = 'fixed';
			overlay.style.top = 0;
			overlay.style.left = 0;
			overlay.style.width = '100%';
			overlay.style.height = '100%';
			overlay.style.background = 'rgba(0,0,0,0.7)';
			overlay.style.display = 'flex';
			overlay.style.alignItems = 'center';
			overlay.style.justifyContent = 'center';
			overlay.style.zIndex = 9999;
			overlay.style.opacity = 0;
			overlay.style.transition = 'opacity 0.3s ease';

			// Style the popup itself
			popupContent.style.display = 'block';
			popupContent.style.zIndex = 10000;
			popupContent.style.background = '#fff';
			popupContent.style.padding = '20px';
			popupContent.style.borderRadius = '8px';
			popupContent.style.maxWidth = '90%';
			popupContent.style.maxHeight = '90%';
			popupContent.style.overflowY = 'auto';
			popupContent.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';

			// Append popup content to overlay
			overlay.appendChild(popupContent);

			// Add overlay to body
			document.body.appendChild(overlay);

			// Fade in
			requestAnimationFrame(() => {
				overlay.style.opacity = 1;
			});

			// Click outside to close
			overlay.addEventListener('click', function (e) {
				if (e.target === overlay) {
					overlay.style.opacity = 0;
					setTimeout(() => {
						// Reset popup content
						popupContent.style.display = 'none';
						document.body.appendChild(popupContent); // move back to original place
						overlay.remove();
					}, 300);
				}
			});
		});
	});
});


function resizePostSliderClips() {
    document.querySelectorAll('.post-slider__flex-container').forEach((container) => {
        const clip = container.querySelector('.post-slider__clip');

        if (!clip) return;

        const rect = clip.getBoundingClientRect();
        const width = window.innerWidth - rect.left;

        clip.style.width = `${width}px`;
        clip.style.flex = `0 0 ${width}px`;

        const slider = clip.querySelector('.post-slider__list');
        const flkty = slider ? Flickity.data(slider) : null;

        if (flkty) {
            flkty.resize();
        }
    });
}

window.addEventListener('load', resizePostSliderClips);
window.addEventListener('resize', resizePostSliderClips);